<script setup lang="ts">
import { computed } from 'vue';
import AvailableIcons from '@/interfaces/AvailableIcons';
import ConnxIcon from '../Atoms/ConnxIcon.vue';

interface Props {
  icon: AvailableIcons;
  text: string;
  link: string;
}
const props = defineProps<Props>();

const renderedText = computed(() => {
  if (props.text.length >= 9) {
    return `${props.text.slice(0, 6)}...`
  }
  return props.text;
})
</script>

<template>
  <a :href="link" :title="text"
    class="tw-w-[68px] tw-h-18 tw-flex tw-justify-between tw-items-center tw-flex-wrap tw-flex-col tw-text-connx-primary tw-border-solid tw-border-transparent hover:tw-border-connx-grey-tint-80 tw-rounded-md tw-pt-2 tw-pb-0 tw-group tw-cursor-pointer tw-no-underline">
    <connx-icon :name="icon" class="group-hover:tw-text-connx-primary-shade-35 tw-mb-2 tw-w-auto !tw-h-8"></connx-icon>
    <p
      class="tw-text-connx-primary tw-mb-0 tw-w-20 tw-text-center group-hover:tw-text-connx-grey group-hover:tw-bg-connx-grey-tint-80 tw-px-2">
      {{ renderedText }}</p>
  </a>
</template>